// extracted by mini-css-extract-plugin
export default {"title":"FE8Au","date":"hBgLg","nowrap":"FiHr6","dateChanged":"i7IMO"};